import { 
  LayoutDashboard, 
  FileText, 
  MessageSquare, 
  ShieldCheck, 
  Globe, 
  Users, 
  FileCheck2, 
  BarChart3, 
  Award, 
  Link2, 
  Calendar, 
  PieChart, 
  Gauge, 
  Search, 
  Activity, 
  Mail, 
  CreditCard, 
  Link as LinkIcon 
} from 'lucide-react';

export type AdminToolItem = {
  id: string;
  label: string;
  shortLabel?: string;
  path: string;
  icon: any;
  description: string;
  superAdminOnly?: boolean;
  badge?: string;
};

export type AdminSection = {
  id: 'overview' | 'content' | 'network' | 'system';
  label: string;
  shortLabel: string;
  icon: any;
  defaultPath: string;
  description: string;
  tools: AdminToolItem[];
};

export const ADMIN_SECTIONS: AdminSection[] = [
  {
    id: 'overview',
    label: 'Overview',
    shortLabel: 'Overview',
    icon: LayoutDashboard,
    defaultPath: '/admin',
    description: 'Central portal dashboard & service metrics',
    tools: [
      {
        id: 'dashboard',
        label: 'Dashboard Home',
        shortLabel: 'Dashboard',
        path: '/admin',
        icon: LayoutDashboard,
        description: 'Admin hub summary and tools overview'
      }
    ]
  },
  {
    id: 'content',
    label: 'Content & Marketing',
    shortLabel: 'Content',
    icon: FileText,
    defaultPath: '/admin/blog',
    description: 'Blog articles, client testimonials, brand trust, and localized regional copy',
    tools: [
      {
        id: 'blog',
        label: 'Blog Articles',
        shortLabel: 'Blog',
        path: '/admin/blog',
        icon: FileText,
        description: 'Publish and edit Insights & Perspectives articles'
      },
      {
        id: 'testimonials',
        label: 'Client Stories',
        shortLabel: 'Stories',
        path: '/admin/testimonials',
        icon: MessageSquare,
        description: 'Manage homepage video testimonials and quotes'
      },
      {
        id: 'trust-logos',
        label: 'Trust & Logos',
        shortLabel: 'Logos',
        path: '/admin/trust-logos',
        icon: ShieldCheck,
        description: 'Corporate client logos and credibility banners'
      },
      {
        id: 'regional-content',
        label: 'Regional Content',
        shortLabel: 'Regions',
        path: '/admin/regional-content',
        icon: Globe,
        description: 'Regional currency, localized headlines, and imagery'
      }
    ]
  },
  {
    id: 'network',
    label: 'Practitioner Network',
    shortLabel: 'Practitioners',
    icon: Users,
    defaultPath: '/admin/practitioners?tab=applications',
    description: 'Onboarding reviews, practitioner directory, analytics, invite links, calendar and commissions',
    tools: [
      {
        id: 'applications',
        label: 'Onboarding Apps',
        shortLabel: 'Applications',
        path: '/admin/practitioners?tab=applications',
        icon: FileCheck2,
        description: 'Review incoming participant onboarding applications'
      },
      {
        id: 'directory',
        label: 'Practitioner Directory',
        shortLabel: 'Directory',
        path: '/admin/practitioners?tab=manage',
        icon: Users,
        description: 'Manage active accredited practitioner profiles'
      },
      {
        id: 'network-analytics',
        label: 'Network Analytics',
        shortLabel: 'Analytics',
        path: '/admin/practitioners?tab=analytics',
        icon: BarChart3,
        description: 'Practitioner growth, coaching rates, and performance stats'
      },
      {
        id: 'links-gen',
        label: 'Link Generator',
        shortLabel: 'Invite Links',
        path: '/admin/practitioners?tab=settings',
        icon: Link2,
        description: 'Generate customized onboarding application links'
      },
      {
        id: 'calendar',
        label: 'Calendar Bookings',
        shortLabel: 'Calendar',
        path: '/admin/calendar',
        icon: Calendar,
        description: 'Global coaching schedule and session bookings'
      },
      {
        id: 'commissions',
        label: 'Commissions',
        shortLabel: 'Commissions',
        path: '/admin/commissions',
        icon: PieChart,
        description: 'Practitioner referral commissions and payouts'
      },
      {
        id: 'dashboard-preview',
        label: 'Portal preview',
        shortLabel: 'Portal preview',
        path: '/admin/practitioners?tab=dashboard-preview',
        icon: LayoutDashboard,
        description: 'Preview practitioner portal with sample data'
      }
    ]
  },
  {
    id: 'system',
    label: 'System & Integrations',
    shortLabel: 'System',
    icon: Activity,
    defaultPath: '/admin/quotas',
    description: 'API monitoring, SEO, tracking analytics, Mailchimp, payments, and users',
    tools: [
      {
        id: 'quotas',
        label: 'API Quotas & Limits',
        shortLabel: 'API Quotas',
        path: '/admin/quotas',
        icon: Gauge,
        description: 'Real-time API rate limits and quota alerts'
      },
      {
        id: 'seo',
        label: 'SEO Manager',
        shortLabel: 'SEO',
        path: '/admin/seo-manager',
        icon: Search,
        description: 'Meta titles, descriptions, and structured data'
      },
      {
        id: 'tracking',
        label: 'Tracking & Analytics',
        shortLabel: 'Tracking',
        path: '/admin/tracking',
        icon: Activity,
        description: 'Google Analytics, Ads IDs, and GTM configuration'
      },
      {
        id: 'mailchimp',
        label: 'Mailchimp Sync',
        shortLabel: 'Mailchimp',
        path: '/admin/mailchimp',
        icon: Mail,
        description: 'Newsletter subscribers and audience integration'
      },
      {
        id: 'payments',
        label: 'Payment Settings',
        shortLabel: 'Payments',
        path: '/admin/payments',
        icon: CreditCard,
        description: 'Payfast credentials and product pricing',
        superAdminOnly: true
      },
      {
        id: 'links-tracker',
        label: 'Links & Forms',
        shortLabel: 'Links Tracker',
        path: '/admin/links',
        icon: LinkIcon,
        description: 'Google Sheets conversion and CTA tracking'
      },
      {
        id: 'users',
        label: 'User Access',
        shortLabel: 'User Roles',
        path: '/admin/users',
        icon: ShieldCheck,
        description: 'Manage admin roles and permission levels',
        superAdminOnly: true
      }
    ]
  }
];
